import { useFormik } from "formik";
import React, { useState } from "react";
import { postDataToTheServer } from "../widgets/api";
import AppURL from "../widgets/AppURL";
import { ToastSuccess, ToastWarning } from "../widgets/ToastMessage";
import { BSToADConvert, BSToADUSFormat } from "../widgets/DateFormat";
import {
  validationAcademicsInfo,
  validationAddressInfo,
  validationBankInfo,
  validationBasicInfo,
  validationSalaryInfo,
} from "../components/hr/create/emp/utils/FormValidate";

export const StaffAddFormData = React.createContext();
const StaffAddFormProvider = ({ children }) => {
  const [currentStep, setStep] = useState(1);
  const initialValues = {
    saluation: "",
    phone: "",
    dobe: "",
    dobn: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    name_nep: "",
    per_add: "",
    marital_status: 2,
    gender: "",
    email: "",
    caste: "",
    religion: "Hinduism",
    citiz_no: "",
    ctz_issue_district: "",
    nid_no: "",
    province: "",
    district: "",
    municipality: "",
    wardno: "",
    add_nep: "",
    house_no: "",
    block_no: "",
    tole: "",
    t_province: "",
    t_district: "",
    t_municipality: "",
    t_wardno: "",
    t_tole: "",
    t_block_no: "",
    tempadd: "",
    t_house_no: "",
    emp_position: "",
    name_of_institution: "",
    level: "",
    faculty: "",
    program: "",
    enrolled_year: "",
    passed_year: "",
    bloodgroup: "",
    father_name: "",
    married_status: "",
    date_of_joining: "",
    date_of_leaving: "",
    lang: "",
    training: "",
    qualification: "",
    bank_holder_name: "",
    account_number: "",
    bank_name: "",
    branch_name: "",
    bank_code: "",
    designation: "",
    initail_salary: "0",
    name_of_insti: "",
    enroll_year: "",
    passed_year: "",
    emp_marksheet: "",
    emp_transcript: "",
    emp_certificate: "",
    ac_level: "",
    ac_faculty: "",
    ac_program: "",
    grade_count: 0,
    grade_amt: 0,
    allowance: 0,
    tax_amt: "",
    pf_amount: "",
    pf_thap_perc: "",
    ss_tax: "",
    insurance: "",
    ss_found: "",
    pf_status: "",
    app_date: "",
    branch_id: "",
    remarks: "",
    status: "1",
    post_allowance: "0",
    extra_period: "0",
    irre_period: "0",
    sem_period: "0",
    holiday_katti: "0",
    holiday_thap: "0",
    pan_no: "",
    hit_kosh: "",
    tax_amt: "",
    nationality: "Nepalese",
    part_full: "",
    teaching: "",
    no_of_teach_hr: "",
    way: "",
    ugc_position: "",
    subj: "",
    faculty: "",
    staff_type: "",
    caste: "",
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema:
      currentStep === 1
        ? validationBasicInfo
        : currentStep === 2
        ? validationAddressInfo
        : currentStep === 3
        ? validationBankInfo
        : currentStep === 4
        ? validationAcademicsInfo
        : validationSalaryInfo,
    onSubmit: async (values, action) => {
      if (currentStep === 1) {
        setStep(2);
      } else if (currentStep === 2) {
        setStep(3);
      } else if (currentStep === 3) {
        setStep(4);
      } else {
        setStep(5);
      }
      const formData = new FormData();
      formData.append("first_name", values.first_name || "");
      if (values.middle_name) {
        formData.append("middle_name", values.middle_name || "");
      }
      formData.append("last_name", values.last_name || "");
      formData.append("name_nep", values.name_nep || "");
      formData.append("dobn", values.dobn);
      if (values.dobn) {
        formData.append("dobe", BSToADUSFormat(values.dobn));
      }
      formData.append("phone", values.phone || "");
      formData.append("user", 1);
      formData.append("email", values.email || "");
      if (values?.bloodgroup) {
        formData.append("bloodgroup", values?.bloodgroup || "");
      }
      if (values.citiz_no) {
        formData.append("citiz_no", values.citiz_no || "");
      }
      formData.append("religion", values.religion || "");
      formData.append("nationality", values.nationality || "");
      formData.append("wardno", values.wardno|| "");
      formData.append("province", values.province|| "");
      formData.append("district", values.district|| "");
      formData.append("municipality", values.municipality|| "");
      formData.append("tole", values.tole|| "");
      formData.append("house_no", values.house_no|| "");
      formData.append("block_no", values.block_no|| "");
      formData.append("is_same_per", values.samePermanent || false);
      formData.append("t_province", values.t_province|| "");
      formData.append("t_district", values.t_district|| "");
      formData.append("t_municipality", values.t_municipality|| "");
      formData.append("t_wardno", values.t_wardno|| "");
      formData.append("t_wardno", values.t_wardno|| "");
      formData.append("t_tole", values.t_tole|| "");
      formData.append("t_house_no", values.t_house_no|| "");
      formData.append("t_block_no", values.t_block_no|| "");
      formData.append("per_add", values.per_add);
      formData.append("add_nep", values.add_nep);
      formData.append("tempadd", values.tempadd);
      formData.append("sms_mob_no", values.sms_mob_no);
      formData.append("father_name", values.father_name);
      if (values?.gender) {
        formData.append("gender", values.gender);
      }
      if (values?.marital_status) {
        formData.append("marital_status", values.marital_status);
      }
      if (values.date_of_joining) {
        formData.append("date_of_joining", values.date_of_joining);
      }
      if (values.date_of_leaving) {
        formData.append("date_of_leaving", values.date_of_leaving);
      }
      if (values.ugc_position) {
        formData.append("ugc_position", values.ugc_position || "");
      }
      formData.append("lang", values.lang);
      formData.append("way", values.way || "");
      formData.append("nationality", values.nationality || "");
      formData.append("training", values.training || "");
      formData.append("branch_id", 1);
      formData.append("qualification", values.qualification || "");
      formData.append("bank_holder_name", values.bank_holder_name || "");
      formData.append("account_number", values.account_number || "");
      formData.append("bank_name", values.bank_name || "");
      formData.append("branch_name", values.branch_name || "");
      formData.append("bank_code", values.bank_code || "");
      if (values.designation) {
        formData.append("designation", values.designation || "");
      }
      formData.append("initail_salary", values.initail_salary || "0");
      formData.append("mem_cate_id", 2);
      formData.append("grade_count", values.grade_count || "0");
      formData.append("grade_amt", values.grade_amt || "0");
      formData.append("allowance", values.allowance || "0");
      formData.append("tax_amt", values.tax_amt || "0");
      formData.append("pf_amount", values.pf_amount || "0");
      formData.append("pf_thap_perc", values.pf_thap_perc || "0");
      formData.append("ss_tax", values.ss_tax || "0");
      formData.append("insurance", values.insurance || "0");
      formData.append("ss_found", values.ss_found || "0");
      if (values.status) {
        formData.append("status", parseInt(values.status) === 2 ? "0" : "1");
      }
      formData.append("remarks", values.remarks);
      formData.append("hired_id", 1);
      formData.append("sem_period", values.sem_period || "0");
      formData.append("holiday_katti", values.holiday_katti || "0");
      formData.append("extra_period", values.extra_period || "0");
      formData.append("post_allowance", values.post_allowance || "0");
      formData.append("irre_period", values.irre_period || "0");
      formData.append("holiday_thap", values.holiday_thap || "0");
      formData.append("pan_no", values.pan_no || "0");
      formData.append("hit_kosh", values.hit_kosh || "0");
      formData.append("tax_amt", values.tax_amt || "0");
      formData.append("part_full", values.part_full || "0");
      formData.append("teaching", values.teaching || "");
      formData.append("no_of_teach_hr", values.no_of_teach_hr || "0");
      formData.append("subj", values.subj || "");
      formData.append("faculty", values.faculty || "");
      formData.append("staff_type", values.staff_type || "");
      formData.append("caste", values.caste || "");
      formData.append("name_of_insti", values.name_of_insti || "");
      formData.append("enroll_year", values.enroll_year || "");
      formData.append("passed_year", values.passed_year || "");
      formData.append("emp_marksheet", values.emp_marksheet || "");
      formData.append("emp_transcript", values.emp_transcript || "");
      formData.append("emp_certificate", values.emp_certificate || "");
      formData.append("ac_level", values.ac_level || "");
      formData.append("ac_faculty", values.ac_faculty || "");
      formData.append("ac_program", values.ac_program || "");
      formData.append("qualification", values.ac_level || "");
      formData.append("name_of_insti", values.name_of_insti || "");
      formData.append("ac_level", values.ac_level || "");
      formData.append("ac_program", values.ac_program || "");
      formData.append("ctz_issue_district", values.ctz_issue_district || "");
      if (currentStep === 5) {
        try {
          await postDataToTheServer(
            AppURL.HR_URL + "hr-employee-create-list-view/",
            formData
          ).then((res) => {
            if (res?.status === 201) {
              ToastSuccess(res?.message);
              setStep(1);
              action.resetForm();
            } else {
              ToastWarning(res?.message);
            }
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
  });
  return (
    <StaffAddFormData.Provider value={{ ...formik, currentStep, setStep }}>
      {children}
    </StaffAddFormData.Provider>
  );
};
export default StaffAddFormProvider;
